import { Fragment, useEffect, useState } from 'react';

import { Input } from 'components/common/form/input';
import Tooltip from 'components/common/tooltip/tooltip';
import RetireTable from 'components/retire-table/retire-table';
import RetireCardButton from './retire-card-button';
import RetireBackButton from './retire-back-button';
import RetireInputName from './retire-input-name';

import config from 'config';
const { OCC_CONTRACT } = config;

import { formatTokenAmount } from 'utils/amounts';
import { sumBigHelper } from 'utils';

import {
  actions as tokensSliceActions,
  selectTokenBalance
} from 'redux/slices/tokens';

const { fetchProjects } = tokensSliceActions;

import { useAppDispatch, useAppSelector } from 'redux/use-hooks';
import { selectAccountId } from 'redux/slices/account';
import useSelectedProjects from 'lib/hooks/use-selected-projects';
import useProjectsSearch from 'lib/hooks/use-projects-search';
import { STEPS } from 'lib/constants';

import BalanceCardIcon from 'components/icons/BalanceCardIcon';
import InfoIcon from 'components/icons/InfoIcon';
import EqualsIcon from 'components/icons/EqualsIcon';

import {
  StyledWrapper,
  StyledLogoWrapper,
  StyledCoinWrapper,
  StyledInputWrapper,
  StyledInputLabel,
  StyledInputValue,
  StyledCoinList,
  StyledCoinItem,
  StyledTextWrap,
  StyledCoin,
  StyledMountText,
  StyledCoinMount,
  StyledIconWrapper
} from './retire-card.style';

const RetireCard = () => {
  const dispatch = useAppDispatch();
  const [name, setName] = useState('');
  const [step, setStep] = useState(STEPS.CHOOSE_PROJECTS);
  const { selected, clearAll, sum, handleSelectOne, handleChangeOne } =
    useSelectedProjects();
  const { items, search, setSearch } = useProjectsSearch();
  const accountId = useAppSelector(selectAccountId);
  const balance: string = useAppSelector((state) => {
    // @ts-ignore
    return selectTokenBalance(state, {
      contractName: OCC_CONTRACT
    });
  });
  useEffect(() => {
    if (accountId) {
      dispatch(
        fetchProjects({ accountId })
      );
    }
  }, [accountId]);

  return (
    <>
      <RetireBackButton action={[step, setStep]} />
      <StyledWrapper className={step}>
        <StyledLogoWrapper>
          <BalanceCardIcon color="#4d4d4c" />
        </StyledLogoWrapper>
        <StyledCoinWrapper>
          <StyledCoinList>
            <StyledCoinItem>
              <StyledTextWrap>
                <StyledCoin>
                  <StyledMountText>OCC</StyledMountText>
                  <Tooltip
                    isMultiline
                    message="An OCC represents one <br /> metric tonne of carbon"
                  >
                    <InfoIcon color="#fabc73" />
                  </Tooltip>
                </StyledCoin>
              </StyledTextWrap>
            </StyledCoinItem>
            {(step === STEPS.ENTER_AMOUNT ||
              step === STEPS.ENTER_RECIPIENT) && (
              <StyledCoinItem>
                <StyledCoinMount>{sum}</StyledCoinMount>
              </StyledCoinItem>
            )}
          </StyledCoinList>
          <StyledIconWrapper>
            <EqualsIcon />
          </StyledIconWrapper>
          <StyledCoinList>
            <StyledCoinItem>
              <StyledTextWrap>
                <StyledCoin>
                  <StyledMountText>Carbon</StyledMountText>
                  <Tooltip message="Per Metric tonne">
                    <InfoIcon color="#fabc73" />
                  </Tooltip>
                </StyledCoin>
              </StyledTextWrap>
            </StyledCoinItem>
            {(step === STEPS.ENTER_AMOUNT ||
              step === STEPS.ENTER_RECIPIENT) && (
              <StyledCoinItem>
                <StyledCoinMount>{sum}</StyledCoinMount>
              </StyledCoinItem>
            )}
          </StyledCoinList>
        </StyledCoinWrapper>
        {step !== STEPS.ENTER_RECIPIENT && (
          <StyledInputWrapper>
            <StyledInputLabel>Available to Retire</StyledInputLabel>
            <StyledInputValue>
              {step === STEPS.ENTER_AMOUNT
                ? formatTokenAmount(sumBigHelper(selected), 24, 5)
                : formatTokenAmount(balance, 24, 5)}
            </StyledInputValue>
          </StyledInputWrapper>
        )}
        {step === STEPS.CHOOSE_PROJECTS && (
          <Fragment>
            <Input
              variant="search"
              type="text"
              name="search"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              placeholder="Search for the name of a project"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
            <RetireTable
              data={items}
              selected={selected}
              handleChange={handleChangeOne}
              handleSelect={handleSelectOne}
              mb="16px"
            />
          </Fragment>
        )}
        {step === STEPS.ENTER_AMOUNT && (
          <RetireTable
            mode="selected"
            selected={selected}
            handleChange={handleChangeOne}
            mb="16px"
          />
        )}
        {step === STEPS.ENTER_RECIPIENT && (
          <RetireInputName dispatch={(value) => setName(value)} />
        )}
        <RetireCardButton
          clearSelectedProjects={clearAll}
          selected={selected}
          sum={sum}
          name={name}
          state={[step, setStep]}
        />
      </StyledWrapper>
    </>
  );
};

export default RetireCard;
